import React from 'react';
import SideBar from '../sideBar/SideBar';

const MainLayout = ({
  sidebarVisible, children, isPremium,
}) => (
  <div className="MainLayout">
    <div className="content">
      <SideBar sidebarVisible={sidebarVisible}
        isPremium={isPremium}
      />
      {children}
    </div>
  </div>
);

export default MainLayout;
